<template>
  <div class="artwork-media-status" :class="`is-${statusValue}`">
    <div class="artwork-media-status__summary">
      <v-progress-circular v-if="active" indeterminate :size="13" :width="2" color="inherit" />
      <v-icon v-else-if="statusValue === 'ready'" small>check_circle</v-icon>
      <v-icon v-else-if="statusValue === 'failed' || statusValue === 'partial'" small>error</v-icon>
      <span>{{ label }}</span>
    </div>
    <div v-if="errors.length" class="artwork-media-status__errors">
      <div v-for="error in errors" :key="error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import {
  failedMediaMessages,
  mediaActive,
  mediaStatus,
  mediaStatusLabel
} from '@/utils/artworkMedia'

export default {
  name: 'ArtworkMediaStatus',
  props: { media: { type: Object, default: () => ({}) } },
  computed: {
    statusValue () {
      const status = mediaStatus(this.media)
      return ['succeeded', 'complete', 'completed'].includes(status) ? 'ready' : status
    },
    active () { return mediaActive(this.media) },
    label () { return mediaStatusLabel(this.media) },
    errors () { return failedMediaMessages(this.media) }
  }
}
</script>

<style scoped>
.artwork-media-status { color: #555; font-size: 11px; line-height: 1.3; margin-top: 7px; }
.artwork-media-status__summary { align-items: center; display: flex; gap: 5px; }
.artwork-media-status.is-ready { color: #276638; }
.artwork-media-status.is-failed, .artwork-media-status.is-partial { color: #a32929; }
.artwork-media-status__errors { margin-top: 3px; }
</style>



// WEBPACK FOOTER //
// src/components/artworks/ArtworkMediaStatus.vue